import { Badge, Collapse, Flex, Space, Typography } from 'antd'
import { TStatusPeriod } from 'src/pages/budget/types'
import { useBudgetListUrgent } from 'src/pages/budget/budgetRequests/hooks'
import { UrgentTable } from './components'
import styles from './styles.module.css'

type Props = {
  budgetPeriodName: string | null
  currentPeriodStatus?: TStatusPeriod
}

export const RequestListUrgent = ({
  budgetPeriodName,
  currentPeriodStatus,
}: Props) => {
  const { budgetListUrgent, filteredBudgetListUrgent } = useBudgetListUrgent()
  const { Text } = Typography

  if (
    !budgetListUrgent ||
    !filteredBudgetListUrgent ||
    budgetListUrgent.length === 0
  )
    return null

  return (
    <Collapse
      items={[
        {
          key: '1',
          label: (
            <Space>
              <Text strong style={{ fontSize: 28 }}>
                Срочные заявки / {budgetPeriodName ?? ''}
              </Text>
              <Badge
                count={filteredBudgetListUrgent.length}
                showZero
                color="white"
                style={{ color: 'black', borderRadius: '4px' }}
              />
            </Space>
          ),
          children: (
            <Flex align="center" justify="center" style={{ minHeight: '15em' }}>
              <UrgentTable
                list={budgetListUrgent}
                filterList={filteredBudgetListUrgent}
                currentPeriodStatus={currentPeriodStatus}
              />
            </Flex>
          ),
        },
      ]}
      defaultActiveKey="1"
      className={styles.collapse}
      expandIconPosition="end"
      style={{ backgroundColor: 'var(--color-orange-30)' }}
    />
  )
}
